import { BuildClass, Do, clamp, fsmData, timer } from '../../universal';
import { React, _ } from '../lib';
import { J2rModalPortal } from './component-react';
import { J2rListComponent } from './component-react-list';
import { Bindings, ConditionalObject, stubDOMRect } from './ui5';
const j2rcball = '****all****';
const j2rcbnull = '****null****';
export class J2rComboBox extends React.Component {
    static globs = {
        flipHeightThreshold: 6 * 21 + 2,
        maxOptionsHeight: 19 * 21 + 2,
        optionRowHeight: 21,
        closeArrowHeight: 22,
    };
    static defaultProps = {
        autoPickOnly: false,
        cl: '',
        disabled: false,
        enforce: true,
        multiple: false,
        noSelectAll: false,
        textView: null,
        value: null,
    };
    mounted;
    appFocusing;
    txt;
    opt;
    root;
    lastPosBox = null;
    constructor(props) {
        super(props);
        Bindings(this, [
            this.closeBox,
            this.evBlur,
            this.evChange,
            this.evClick,
            this.evFocus,
            this.getOptions,
            this.getValueRaw,
            this.moveSelection,
            this.onKeyPress,
            this.selectValue,
            this.setOptionPosition,
            this.toggleSelected,
            this.updateText,
            this.validateValue,
        ]);
        this.mounted = false;
        this.appFocusing = false;
        this.txt = React.createRef();
        this.opt = React.createRef();
        this.root = React.createRef();
        this.state = {
            canSendUpdates: false,
            isActive: false,
            isEnteringMode: false,
            isOpen: false,
            isInvalid: false,
            backspacePressed: false,
            optionsPos: {
                left: 0,
                top: 28.8,
                height: 400,
                width: 300,
                minWidth: 0,
                isDown: false,
            },
            fixedWidth: props.fixedWidth,
            selected: null,
            value: props.value ?? (props.multiple ? [] : j2rcbnull),
            valueLast: props.value ?? (props.multiple ? [] : j2rcbnull),
            valueLastBroadcast: props.value ?? (props.multiple ? [] : j2rcbnull),
            valueRaw: this.getValueRaw(props.value),
            valueEntered: '',
        };
    }
    render() {
        return (React.createElement("div", { ref: this.root, title: this.props.title, className: BuildClass({
                j2rcombobox: true,
                [this.props.cl ?? '']: true,
                isActive: this.state.isActive,
                isOpen: this.state.isOpen,
                isInvalid: this.state.isInvalid,
                disabled: this.props.disabled ?? false,
                multiple: this.props.multiple ?? false,
            }) },
            this.buildInput(),
            this.props.multiple ? this.buildMultiInput() : undefined,
            this.buildArrow(),
            this.buildOptionListModal()));
    }
    buildInput() {
        return (React.createElement("input", { key: "input", className: "txt", ref: this.txt, disabled: this.props.disabled ? true : undefined, placeholder: this.props.placeholder, tabIndex: this.props.tabIndex, autoFocus: this.props.autoFocus, autoComplete: "new-password", "data-lpignore": true, value: Do(() => {
                const val = this.props.multiple
                    ? this.state.valueEntered
                    : this.state.valueRaw;
                return val ?? '';
            }), onChange: this.evChange, onKeyDown: this.onKeyPress, onClick: this.evClick, onFocus: this.evFocus, onBlur: this.evBlur }));
    }
    evChange(e) {
        this.updateText(e.target.value);
    }
    evClick() {
        if (this.props.disabled) {
            return;
        }
        this.setState({ isOpen: true });
    }
    evFocus(e) {
        if (this.props.disabled) {
            return;
        }
        this.setState({
            isActive: true,
            isOpen: !this.appFocusing,
        }, () => {
            ;
            (this.props.onFocus ?? _.noop)(e);
        });
        this.appFocusing = false;
    }
    evBlur() {
        this.setState((s) => ({
            ...s,
            isActive: false,
            isOpen: false,
            isEnteringMode: false,
            valueEntered: '',
            selected: null,
            valueRaw: this.getValueRaw(s.value),
        }), () => {
            this.validateValue();
        });
    }
    buildMultiInput() {
        return (React.createElement("input", { key: "input-readonly", className: "txt txtReadonly", readOnly: true, placeholder: this.props.placeholder, value: this.state.valueRaw, tabIndex: -1, onClick: e => {
                e.preventDefault();
                e.stopPropagation();
                if (this.props.disabled) {
                    return;
                }
                timer(() => this.txt.current?.focus());
            } }));
    }
    buildArrow() {
        return (React.createElement("span", { key: "arrow", className: "arrow noselect", onMouseDown: e => {
                e.preventDefault();
                e.stopPropagation();
            }, onClick: e => {
                e.preventDefault();
                e.stopPropagation();
                if (this.props.disabled) {
                    return;
                }
                if (this.state.isOpen) {
                    this.closeBox(false);
                }
                else {
                    this.txt.current?.focus();
                    this.setState({ isOpen: true });
                }
            } },
            React.createElement("img", { key: "arrow-img", className: "arrow-img", src: "/static/img/svg/cb-arrow.svg" })));
    }
    buildOptionListModal() {
        return (React.createElement(J2rModalPortal, { key: "modal-options-outer" }, this.buildOptionListWrapper()));
    }
    buildOptionListWrapper() {
        return (React.createElement("div", { key: "options-wrapper", className: BuildClass({
                'j2rcombobox-options': true,
                hidden: !this.state.isOpen,
                isFlippedUp: !this.state.optionsPos.isDown,
                multi: this.props.multiple ?? false,
            }), style: {
                top: `${this.state.optionsPos.top}px`,
                maxHeight: `${this.state.optionsPos.height}px`,
                left: `${this.state.optionsPos.left}px`,
                minWidth: `${this.state.optionsPos.minWidth}px`,
                width: ConditionalObject(this.state.fixedWidth != null, `${this.state.fixedWidth}px`),
            } }, ConditionalObject(this.state.isOpen, () => this.buildOptionList())));
    }
    buildOptionList() {
        const options = this.getOptions();
        return (React.createElement(J2rListComponent, { key: "options", ref: this.opt, lazyRenderHeight: 21, lazyRenderViewportHeightOverride: 400, headingRow: ConditionalObject(Boolean(this.props.multiple), () => ({
                cl: 'item close-dropdown',
                key: 'close-dropdown',
                title: 'Close dropdown',
                children: [
                    {
                        tag: 'img',
                        key: 'arrow-img',
                        cl: 'arrow-img',
                        src: '/static/img/svg/cb-arrow.svg',
                    },
                ],
                onMouseDown: (e) => {
                    e.preventDefault();
                    e.stopPropagation();
                },
                onClick: (e) => {
                    e.stopPropagation();
                    e.preventDefault();
                    this.closeBox(true);
                },
            })), items: fsmData(options ?? [], {
                filter: opt => opt.visible ?? true,
                map: (opt, index) => this.buildOption(opt, options, index),
            }) }));
    }
    buildOption(opt, options, index) {
        return {
            tag: 'span',
            cl: BuildClass({
                [opt.cl ?? '']: true,
                selected: opt.value === this.state.value,
                highlight: opt.value != null && opt.value === this.state.selected,
                'no-select': !opt.selectable,
                showAll: opt.value === j2rcball,
                [`indent-${opt.indent}`]: !this.state.isEnteringMode,
            }),
            value: opt.value ?? `__no_val_index-${index}`,
            title: opt.title ?? opt.text,
            style: opt.style,
            onMouseDown: (e) => {
                e.preventDefault();
                e.stopPropagation();
            },
            children: [
                ConditionalObject(Boolean(this.props.multiple), {
                    tag: 'input',
                    key: 'check',
                    type: 'checkbox',
                    tabIndex: -1,
                    readOnly: true,
                    checked: Do(() => {
                        if (_.includes(this.state.value, opt.value)) {
                            return true;
                        }
                        else if (opt.value === j2rcball) {
                            const options_filtered = fsmData(options, {
                                filter: v => v.value !== j2rcball && v.selectable,
                                map: v => v.value,
                            });
                            if (_.intersection(options_filtered, this.state.value)
                                .length === options_filtered.length) {
                                return true;
                            }
                            return false;
                        }
                        return false;
                    }),
                    onClick: (e) => {
                        e.stopPropagation();
                        e.preventDefault();
                        if (this.props.multiple &&
                            e.shiftKey &&
                            this.state.value.length > 0) {
                            const prevValue = _.last(this.state.value);
                            const options = this.getRawOptionsFlat();
                            const firstIndex = _.findIndex(options, x => x.value ===
                                (typeof prevValue === 'object'
                                    ? prevValue.value
                                    : prevValue));
                            const secondIndex = _.findIndex(options, x => x.value === opt.value);
                            let values = [];
                            values =
                                firstIndex < secondIndex
                                    ? _.slice(options, firstIndex, secondIndex + 1)
                                    : _.slice(options, secondIndex, firstIndex + 1);
                            timer(() => {
                                this.selectValue(_.map(values, v => v.value));
                            });
                        }
                        else {
                            timer(() => {
                                this.selectValue(opt.value);
                            });
                        }
                        return false;
                    },
                }),
                {
                    tag: 'span',
                    key: 'text',
                    text: !this.state.isEnteringMode ? opt.text : undefined,
                    title: !this.state.isEnteringMode
                        ? (opt.title ?? opt.fullText)
                        : undefined,
                    dangerouslySetInnerHTML: this.state.isEnteringMode
                        ? this.getOptionText(opt.fullText)
                        : undefined,
                },
            ],
            onClick: (e) => {
                e.preventDefault();
                e.stopPropagation();
                if (opt.selectable) {
                    if (this.props.multiple &&
                        e.shiftKey &&
                        this.state.value.length > 0) {
                        const prevValue = _.last(this.state.value);
                        const options = this.getRawOptionsFlat();
                        const firstIndex = _.findIndex(options, x => x.value ===
                            (typeof prevValue === 'object'
                                ? prevValue.value
                                : prevValue));
                        const secondIndex = _.findIndex(options, x => x.value === opt.value);
                        let values = [];
                        values =
                            firstIndex < secondIndex
                                ? _.slice(options, firstIndex, secondIndex + 1)
                                : _.slice(options, secondIndex, firstIndex + 1);
                        this.selectValue(_.map(values, v => v.value));
                    }
                    else {
                        this.selectValue(opt.value);
                    }
                }
            },
        };
    }
    componentWillUnmount() {
        this.mounted = false;
        this.setState({ canSendUpdates: false });
    }
    componentDidMount() {
        this.mounted = true;
        this.setOptionPosition();
        this.validateValue();
        timer(() => {
            if (this.mounted) {
                this.setState({ canSendUpdates: true }, () => {
                    if (this.props.autoPickOnly &&
                        this.getRawOptionsFlat().length === 1) {
                        const v = this.getRawOptionsFlat()[0]?.value;
                        this.setState({
                            value: v,
                            valueRaw: this.getValueRaw(v),
                        }, () => {
                            this.validateValue();
                        });
                    }
                });
            }
        });
    }
    componentDidUpdate(prevProps, prevState) {
        if (prevState.isOpen !== this.state.isOpen) {
            timer(100, () => {
                if (this.mounted) {
                    this.setState(s => ({
                        fixedWidth: this.props.fixedWidth ??
                            Do(() => {
                                if (s.isOpen) {
                                    return ((this.getListElement()?.getBoundingClientRect()
                                        .width ?? 0) + 2);
                                }
                                return null;
                            }),
                    }));
                }
            });
        }
        const changedValueMetrics = [
            !_.isEqual(prevProps.value, this.props.value),
            prevProps.textView !== this.props.textView,
        ];
        const changedBoxMetrics = [
            prevProps.multiple !== this.props.multiple,
            !_.isEqual(prevProps.options, this.props.options),
        ];
        const changedValue = _.some(changedValueMetrics);
        const changedBox = _.some(changedBoxMetrics);
        const delta = {};
        if (changedBox) {
            _.assign(delta, {
                isEnteringMode: false,
                isOpen: false,
                valueRaw: this.getValueRaw(),
            });
        }
        if (changedValue) {
            const emptyVal = this.props.multiple ? [] : j2rcbnull;
            _.assign(delta, {
                value: this.props.value ?? emptyVal,
                valueLastBroadcast: this.props.value ?? emptyVal,
                valueRaw: this.getValueRaw(this.props.value, this.props),
                valueEntered: '',
                valueLast: this.state.value,
            });
        }
        if (_.size(delta) > 0) {
            this.setState(delta, () => {
                this.setOptionPosition();
            });
            return;
        }
        this.setOptionPosition();
    }
    setOptionPosition() {
        let height, is_down, top;
        const glob = J2rComboBox.globs;
        const posBox = (this.state.isOpen
            ? this.root.current?.getBoundingClientRect()
            : this.lastPosBox) ?? { ...stubDOMRect, width: 200 };
        this.lastPosBox = posBox;
        const boundingBox = {
            left: 0,
            top: 0,
            x: 0,
            y: 0,
            bottom: window.innerHeight,
            height: window.innerHeight,
            right: window.innerWidth,
            width: window.innerWidth,
        };
        const max_height = Do(() => {
            const max_height_needed = Do(() => {
                let c = this.getRawOptionsFlat().length * glob.optionRowHeight + 2;
                if (this.props.nullable != null) {
                    c += glob.optionRowHeight;
                }
                if (this.props.multiple && !this.props.noSelectAll) {
                    c += glob.optionRowHeight + 1;
                }
                if (this.props.multiple) {
                    c += glob.closeArrowHeight;
                }
                return c;
            });
            return clamp(max_height_needed, 0, glob.maxOptionsHeight);
        });
        const height_down = clamp(boundingBox.bottom - posBox.bottom, 0, max_height);
        const height_up = clamp(posBox.top - boundingBox.top, 0, max_height);
        if (height_down < glob.flipHeightThreshold && height_up > height_down) {
            top = posBox.top - height_up;
            height = height_up;
            is_down = false;
        }
        else {
            top = posBox.bottom - 1;
            height = height_down;
            is_down = true;
        }
        const newObj = {
            isDown: is_down,
            left: posBox.left,
            top: top,
            minWidth: posBox.width,
            width: this.state.optionsPos.width ?? posBox.width,
            height: height,
        };
        if (!_.isEqual(newObj, this.state.optionsPos)) {
            this.setState({ optionsPos: newObj });
        }
    }
    onKeyPress(e) {
        this.setState({ backspacePressed: false });
        switch (e.which) {
            case 27:
                this.closeBox(false);
                e.preventDefault();
                break;
            case 13:
                if (this.props.multiple) {
                    const opts = this.getOptions();
                    if (this.state.selected === null &&
                        opts.length === 1 &&
                        opts[0]?.value !== j2rcball) {
                        this.selectValue(opts[0]?.value);
                    }
                    else {
                        this.toggleSelected(e);
                    }
                }
                this.closeBox(true);
                e.preventDefault();
                break;
            case 9:
                this.updateText(this.state.valueRaw ?? '', false);
                break;
            case 32:
                if (this.props.multiple && this.props.selected != null) {
                    e.preventDefault();
                    e.stopPropagation();
                }
                this.toggleSelected(e);
                break;
            case 40:
                this.moveSelection(+1);
                e.preventDefault();
                break;
            case 34:
                this.moveSelection(+12);
                e.preventDefault();
                break;
            case 38:
                this.moveSelection(-1);
                e.preventDefault();
                break;
            case 33:
                this.moveSelection(-12);
                e.preventDefault();
                break;
            case 39:
                this.setState(prev => ({
                    valueEntered: prev.valueRaw ?? '',
                }));
                break;
            case 8:
            case 46:
                this.setState({ backspacePressed: true });
                break;
        }
    }
    selectValue(val) {
        let value, valueRaw;
        if (!this.mounted) {
            return;
        }
        if (!this.props.multiple) {
            this.setState({ isOpen: false });
            valueRaw = this.getValueRaw(val);
            if (this.state.value === val && this.state.valueRaw === valueRaw) {
                return;
            }
            this.setState({
                value: val,
                valueRaw,
                valueLast: this.state.value,
            }, () => {
                this.validateValue();
            });
            return;
        }
        if (val === j2rcball) {
            const options = fsmData(this.getOptions(), {
                filter: v => v.value !== j2rcball && v.selectable,
                map: v => v.value,
            });
            if (_.intersection(options, this.state.value).length === options.length) {
                value = this.state.value.filter((x) => !_.includes(options, x));
            }
            else {
                value = _.uniq(this.state.value.concat(options));
            }
            this.setState({
                valueEntered: '',
            });
        }
        else if (Array.isArray(val)) {
            value = _.uniq(this.state.value.concat(val));
        }
        else {
            value = Do(() => {
                if (this.state.value.indexOf(val) !== -1) {
                    return this.state.value.filter((x) => x !== val);
                }
                return this.state.value.concat(val);
            });
            this.setState({
                valueEntered: '',
                selected: val,
            });
        }
        valueRaw = this.getValueRaw(value);
        if (this.state.value === value && this.state.valueRaw === valueRaw) {
            return;
        }
        this.setState({
            value,
            valueRaw,
            valueLast: this.state.value,
        }, () => {
            this.validateValue();
        });
    }
    toggleSelected(e) {
        if (!this.props.multiple) {
            return;
        }
        if (this.state.selected) {
            this.selectValue(this.state.selected);
            e.preventDefault();
        }
    }
    getValueRaw(val = this.state.value, props = this.props) {
        let text;
        const optLength = _.size(_.filter(this.getRawOptionsFlat(props), x => x.selectable));
        if (props.textView != null) {
            text = props.textView(val, (val?.length ?? 0) === optLength);
            if (text != null) {
                return text;
            }
        }
        if (val == null) {
            val = j2rcbnull;
        }
        if (!props.multiple) {
            return fsmData(_.concat(this.getOptions(props)), {
                filter: o => o.value === val,
                map: o => o?.text ?? '',
                takeFirst: true,
            });
        }
        const matches = fsmData(this.getRawOptionsFlat(props), {
            filter: o => _.includes(val, o.value),
            map: o => o.text,
        });
        if (matches.length === optLength) {
            return 'All Selected';
        }
        if (matches.length > 2) {
            return `${matches.length} Selected`;
        }
        return matches.join(', ');
    }
    getOptions(props = this.props) {
        const isEnteringMode = this.state?.isEnteringMode ?? false;
        let options = this.getRawOptionsFlat(props);
        options = fsmData(options, {
            filter: opt => {
                if (!isEnteringMode) {
                    return true;
                }
                if (!opt.selectable) {
                    return false;
                }
                const tl = (s) => s.toLowerCase();
                return tl(opt.fullText).indexOf(tl(this.state.valueEntered)) !== -1;
            },
            sort: opt => {
                if (!isEnteringMode) {
                    return 1;
                }
                const tl = (s) => s.toLowerCase();
                const prefix_match = tl(opt.text).startsWith(tl(this.state.valueEntered));
                return prefix_match ? 0 : 1;
            },
        });
        if (props.nullable != null && !isEnteringMode) {
            options.unshift({
                value: j2rcbnull,
                selectable: true,
                text: props.nullable,
                fullText: '',
                indent: 0,
            });
        }
        if (props.multiple && !props.noSelectAll && options.length !== 1) {
            const lbl = Do(() => {
                if (options.length === 0) {
                    return 'No options meet this filter';
                }
                else if (options.length !== this.getRawOptionsFlat(props).length) {
                    return 'Select Filtered';
                }
                return 'Select All';
            });
            options.unshift({
                value: j2rcball,
                selectable: true,
                fullText: lbl,
                text: lbl,
                indent: 0,
            });
        }
        return options;
    }
    getRawOptionsFlat(props = this.props) {
        const options = [];
        _.forEach(props.options, opt => {
            if (!('options' in opt)) {
                options.push(_.assign({}, opt, {
                    selectable: true,
                    fullText: opt.text,
                    indent: 0,
                }));
                return;
            }
            options.push({
                selectable: false,
                text: opt.text,
                cl: BuildClass({
                    [opt.cl ?? '']: true,
                    'group-heading': true,
                }),
                title: opt.title,
                fullText: opt.text,
                indent: 0,
            });
            _.forEach(opt.options, o => options.push(_.assign({}, o, {
                selectable: true,
                fullText: `${opt.prefix ?? opt.text} → ${o.text}`,
                indent: 1,
            })));
        });
        return options;
    }
    getListElement() {
        return this.opt.current?.listElement.current;
    }
    getOptionText(s) {
        if (!this.state || !this.state.isEnteringMode) {
            return { __html: s };
        }
        const val = this.state.valueEntered.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
        const q = new RegExp(`(${val})`, 'gi');
        s = s.replace(q, '<em>$1</em>');
        return { __html: s };
    }
    moveSelection(delta) {
        const selectedVal = Do(() => {
            if (this.props.multiple) {
                return this.state.selected;
            }
            return this.state.value;
        });
        const options = this.getOptions();
        let index = -1;
        _.forEach(options, (opt, i) => {
            if (opt.value != null && opt.value === selectedVal) {
                index = i;
                return false;
            }
            return undefined;
        });
        index += delta;
        while (options[index]?.selectable === false) {
            index += delta / Math.abs(delta);
        }
        while (options[index]?.selectable !== true) {
            index -= delta / Math.abs(delta);
        }
        const listEl = this.getListElement();
        if (listEl != null) {
            const opt_height = listEl.clientHeight;
            const top = listEl.scrollTop;
            const bot = top + opt_height;
            const offset_top = index * J2rComboBox.globs.optionRowHeight;
            const offset_bot = offset_top + J2rComboBox.globs.optionRowHeight;
            if (offset_top < top) {
                listEl.scrollTo(0, offset_top);
            }
            else if (offset_bot > bot) {
                listEl.scrollTo(0, offset_bot - opt_height);
            }
        }
        if (this.props.multiple) {
            this.setState({ selected: options[index]?.value });
        }
        else {
            this.setState({
                value: options[index]?.value,
                valueRaw: this.getValueRaw(options[index]?.value),
                valueLast: this.state.value,
            });
        }
    }
    closeBox(keep_state_change) {
        this.setState({ isOpen: false });
        if (!keep_state_change && !this.props.multiple) {
            this.setState(s => ({
                isEnteringMode: false,
                valueRaw: this.getValueRaw(s.value),
                valueEntered: '',
            }));
        }
        if (keep_state_change) {
            this.updateText(this.state.valueRaw, false);
            this.setState({ isOpen: false });
        }
    }
    updateText(text, enteredManually = true) {
        if (this.props.disabled) {
            return;
        }
        this.setState({ isOpen: true });
        if (this.props.multiple) {
            this.setState({
                valueEntered: text ?? '',
                isEnteringMode: enteredManually && text.length > 0,
            });
            return;
        }
        this.setState({ valueRaw: text });
        const options = this.getRawOptionsFlat();
        const matches = options.filter(opt => opt.text.toLowerCase() === text.toLowerCase());
        if (matches.length > 0) {
            this.setState({
                value: matches[0]?.value,
                valueRaw: this.getValueRaw(matches[0]?.value),
                isEnteringMode: enteredManually,
                valueLast: this.state.value,
            }, () => {
                this.validateValue();
            });
            return;
        }
        const selectionAtEnd = Do(() => {
            const [selStart, selEnd] = [
                this.txt.current?.selectionStart,
                this.txt.current?.selectionEnd,
            ];
            return selStart === selEnd && selStart === text.length;
        });
        let index = 0;
        let suffix = '';
        if (!this.state.backspacePressed && selectionAtEnd) {
            const matches = fsmData(options, {
                filter: o => o.text.toLowerCase().startsWith(text.toLowerCase()),
                map: o => o.text,
            });
            const minLength = _.min(matches.map(t => t.length));
            if (minLength != null) {
                while (index < minLength) {
                    const diffs = _.uniq(matches.map(t => t[index]?.toLowerCase() ?? ''));
                    if (diffs.length > 1) {
                        break;
                    }
                    index += 1;
                }
            }
            suffix = matches[0]?.slice(text.length, index) ?? '';
            if (matches.length > 1) {
                suffix = suffix.toLowerCase();
            }
        }
        this.setState({
            value: null,
            valueEntered: text ?? '',
            valueRaw: text + suffix,
            isEnteringMode: enteredManually && text.length > 0,
            valueLast: this.state.value,
        }, () => {
            if (suffix) {
                this.txt.current?.setSelectionRange(text.length, index);
            }
        });
    }
    validateValue() {
        this.setState({ isInvalid: false });
        const record = {
            value: Do(() => {
                if (this.state.value === j2rcbnull) {
                    return null;
                }
                return this.state.value || null;
            }),
            valueLast: Do(() => {
                if (this.state.valueLast === j2rcbnull) {
                    return null;
                }
                return this.state.valueLast || null;
            }),
            text: this.state.valueRaw,
            isNull: this.state.value === j2rcbnull,
        };
        const bools = [!this.props.enforce, record.isNull, Boolean(record.value)];
        if (_.sum(bools) > 0) {
            if (this.state.canSendUpdates &&
                !_.isEqual(record.value, this.state.valueLastBroadcast)) {
                this.setState({ valueLastBroadcast: record.value });
                (this.props.onUpdate ?? _.noop)(record);
            }
            return;
        }
        const value = null;
        const valueRaw = this.getValueRaw(null);
        if (value !== this.state.value || valueRaw !== this.state.valueRaw) {
            this.setState({
                value,
                valueRaw,
            }, () => {
                this.validateValue();
            });
        }
    }
    Focus(open_as_well = false) {
        if (!open_as_well) {
            this.appFocusing = true;
        }
        this.txt.current?.focus();
    }
}
//# sourceMappingURL=component-combobox.js.map